import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import theme from './theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import 'leaflet/dist/leaflet.css';
import { AppStateProvider } from './context/AppStateProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppStateProvider>
    <React.StrictMode>
      <ThemeProvider theme={theme} >
        <App />
      </ThemeProvider>
    </React.StrictMode>
  </AppStateProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
